precision highp float;

const vec3 LIGHT_COLOR = vec3(1.0, 1.0, 0.9);
const vec3 AMBIENT_LIGHT = vec3(0.7, 0.7, 0.7);

uniform sampler2D tSurfaceColor;
uniform sampler2D heightMap;
uniform vec3 uFogColor;
uniform float uFogNear;
uniform float uFogFar;
uniform vec3 uGrassFogColor;
uniform float uGrassFogFar;

varying vec3 vPosition;
varying vec4 vColor;
varying vec2 vUv;
varying float vHidden;

void main() {

	// output
  if(vHidden == 0.0) {
    vec4 color = vec4(vColor) * texture2D(tSurfaceColor, vec2(vUv.s, vUv.t));
    float depth = gl_FragCoord.z / gl_FragCoord.w;
	// apply 'grass fog' first

    gl_FragColor = vec4(color.rgb, 1.0);
  } else {
    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
  }
}